export enum Role {
  admin = 'admin',
  diretor = 'diretor',
  financeiro = 'financeiro',
  consultor = 'consultor',
  client = 'client'
}
